import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const repoTesterApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGitlab: builder.query({
      query: (slug) => (`/publishers/${slug}/gitlab`)
    }),
    getArtifactory: builder.query({
      query: (slug) => (`/publishers/${slug}/artifactory`)
    })
  }),
  overrideExisting: false
})

export const {
  useLazyGetGitlabQuery,
  useLazyGetArtifactoryQuery
} = repoTesterApiSlice
